import { render, staticRenderFns } from "./BasicLoading.vue?vue&type=template&id=4a24d7ec&scoped=true"
var script = {}
import style0 from "./BasicLoading.vue?vue&type=style&index=0&id=4a24d7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a24d7ec",
  null
  
)

export default component.exports